import { ProductSlug } from "@/api/product-api";

export type ProductInTheBoxData = Partial<
  Record<ProductSlug, { title: string; src: string }[]>
>;

export type ProductInTheBoxItem = { title: string; src: string };

const BASE_PATH = "/images/shop/details";

const CHARGING_CABLE = {
  title: "USB Type C Charging Cable",
  src: `${BASE_PATH}/tactvisor-box-1.png`,
};
export const TACTSUIT_AIR_CAMO_PREORDER_BADGE = {
  title: "TactSuit Air: Camo Pre-order Badge",
  src: `${BASE_PATH}/tactsuit-air-camo-preorder-badge@1x.png`,
};
const CHARGING_CABLE_PAIR = {
  title: "USB Type C Charging Cable (Pair)",
  src: `${BASE_PATH}/tactglove-box-1.png`,
};
const MANUAL = {
  title: "User Manual",
  src: `${BASE_PATH}/tactglove-box-2.png`,
};
const TACTGLOVE = {
  title: "TactGloves* (Pair)",
  src: `${BASE_PATH}/tactglove-box-0.png`,
};
const BLE_DONGLE = {
  title: "Bluetooth Dongle",
  src: `${BASE_PATH}/tactosy-for-feet-box-1.png`,
};
const AUDIO_ACCESSARY = {
  title: "TactSuit Audio Accessories",
  src: `${BASE_PATH}/tactsuit-air-box-3.png`,
};
const TACTSLEEVE = {
  title: "TactSleeve",
  src: `${BASE_PATH}/tactsleeve-box-0.png`,
};
const TACTSUIT_AIR = {
  title: "TactSuit Air\n (Ash or Onyx)",
  src: "https://cdn.bhaptics.com/images/products/air-white-red.png",
};

const TACTSUIT_AIR_CAMO = {
  title: "TactSuit Air (Camo)",
  src: "https://cdn.bhaptics.com/images/products/air-camo-01.png",
};

const TACTSUIT_PRO = {
  title: "TactSuit Pro",
  src: "https://cdn.bhaptics.com/images/products/pro-0.png",
};

const X16_MESH_LINING = {
  title: "Additional Mesh Lining for TactSuit X16",
  src: `${BASE_PATH}/tactsuit-x16-box-5.png`,
};
const X16 = {
  title: "TactSuit X16 ",
  src: `${BASE_PATH}/tactsuit-x16-box-0.png`,
};
const TACTOSY_FOR_FEET = {
  title: "Tactosy for Feet (Pair)",
  src: `${BASE_PATH}/tactosy-for-feet-box-0.png`,
};
const TACTVISOR = {
  title: "TactVisor",
  src: `${BASE_PATH}/tactvisor-box-0.png`,
};
const VIVE_TRACKER_PAIR = {
  title: "HTC Vive Tracker Mounting Modules (Pair)",
  src: `${BASE_PATH}/tactosy-for-feet-box-2.png`,
};
const EXTENSION_STRAP_PAIR = {
  title: "Extension Straps (Pair)",
  src: `${BASE_PATH}/tactosy-for-feet-box-3.png`,
};
const VELCRO_STICKER = {
  title: "Velcro Sticker",
  src: `${BASE_PATH}/tactvisor-box-3.png`,
};

const METRO_BADGE = {
  title: "Metro Badge",
  src: `${BASE_PATH}/metro_badge@1x.png`,
};

const ASR_BADGE = {
  title: "ASR Badge",
  src: `${BASE_PATH}/asr_badge@1x.png`,
};

/**
 * EXOSHOCK 번들 — Air 박스와 같은 구성인데 1번 이미지가 가슴 와펜을 EXOSHOCK 으로 바꾼 Air 다
 * (피그마 `31584:38714` · `exoshock-bundle-air-01`, 2026-10-28).
 */
const EXOSHOCK_BUNDLE_AIR = {
  title: "TactSuit Air\n(Onyx)",
  src: "/images/tactsuit/exoshock-bundle/box-air.png",
};

const TACTSUIT_AIR_BOX = [
  TACTSUIT_AIR,
  BLE_DONGLE,
  CHARGING_CABLE,
  AUDIO_ACCESSARY,
  MANUAL,
];

const TACTSUIT_AIR_CAMO_BOX = [
  TACTSUIT_AIR_CAMO,
  BLE_DONGLE,
  CHARGING_CABLE,
  AUDIO_ACCESSARY,
  MANUAL,
];

const TACTSUIT_PRO_BOX = [
  TACTSUIT_PRO,
  BLE_DONGLE,
  CHARGING_CABLE,
  AUDIO_ACCESSARY,
  MANUAL,
];
const TACTSLEEVE_BOX = [TACTSLEEVE, CHARGING_CABLE_PAIR, MANUAL];
const TACTVISOR_BOX = [TACTVISOR, CHARGING_CABLE, VELCRO_STICKER, MANUAL];
const TACTOSY_FOR_FEET_BOX = [
  TACTOSY_FOR_FEET,
  BLE_DONGLE,
  VIVE_TRACKER_PAIR,
  EXTENSION_STRAP_PAIR,
  CHARGING_CABLE_PAIR,
  MANUAL,
];

export const ProductInTheBoxData: ProductInTheBoxData = {
  [ProductSlug.METRO_BUNDLE]: [...TACTSUIT_PRO_BOX, METRO_BADGE],
  [ProductSlug.ARIZONA_BUNDLE]: [...TACTSUIT_AIR_BOX, ASR_BADGE],
  [ProductSlug.TACTGLOVE_DK2]: [TACTGLOVE, CHARGING_CABLE_PAIR, MANUAL],
  // DK3 박스 구성은 DK2 와 동일 (글러브 + 충전 케이블 + 매뉴얼). 박스 이미지는 버전 중립.
  [ProductSlug.TACTGLOVE_DK3]: [TACTGLOVE, CHARGING_CABLE_PAIR, MANUAL],
  [ProductSlug.EXOSHOCK_BUNDLE]: [
    EXOSHOCK_BUNDLE_AIR,
    BLE_DONGLE,
    CHARGING_CABLE,
    AUDIO_ACCESSARY,
    MANUAL,
  ],
  [ProductSlug.TACTOSY_FOR_FEET]: TACTOSY_FOR_FEET_BOX,
  [ProductSlug.TACTVISOR]: TACTVISOR_BOX,
  [ProductSlug.TACTSUIT_X16]: [
    X16,
    X16_MESH_LINING,
    BLE_DONGLE,
    CHARGING_CABLE,
    AUDIO_ACCESSARY,
    MANUAL,
  ],
  [ProductSlug.TACTSUIT_PRO]: TACTSUIT_PRO_BOX,
  [ProductSlug.TACTSUIT_AIR]: TACTSUIT_AIR_BOX,
  [ProductSlug.TACTSUIT_AIR_CAMO]: TACTSUIT_AIR_CAMO_BOX,
  [ProductSlug.TACTSLEEVE]: TACTSLEEVE_BOX,
};
